import React, { useState } from 'react';
import '../css/Main.css';

function HoverImage({href, logoSrc}) {
  
const [hover, setHover] = useState(false);

  return (
    <div
      className={`box ${hover ? 'hover' : ''}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
        <a href={href} target='_blank'>
            <img src={logoSrc} style={styles.linkLogo} />
        </a>
    </div>
  );
}

const styles = {
    linkLogo: {
        width: '100px',
        height: 'auto'
      }
}

export default HoverImage;